var map = {
	"./card-btn-arrow.svg": 68238,
	"./close-icon-round.svg": 58881,
	"./close.svg": 16802,
	"./drop-down-arrow.svg": 22351,
	"./error-cross.svg": 22974,
	"./error-exclamation.svg": 21869,
	"./ic-info-outline.svg": 53257,
	"./success-tick.svg": 38926,
	"./warning.svg": 57020,
	"./white-tick.svg": 2117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55423;